module.exports = __webpack_public_path__ + "static/media/ethereumLogo.0020ce37.png";